module.exports = __webpack_public_path__ + "static/media/eimi-fukada.6a25cf1a.jpg";